import { useContext, useState } from "react";
import { IMAGE } from "../../../../config/constant";
import { patchUserProfile } from "../../../../services/httpService/userRequest";
import { updateUserProfileValidator } from "../../../../validators/UserValidator";
import { GlobalContext } from "../../../contexts/globalContext";
import InputText from "../../atoms/InputText/InputText";
import Modal from "../../atoms/Modal/Modal";

const ModalUserProfile = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [state, setState] = useState({
    name: sharedState.user.name,
    description: sharedState.user.profile.description || "",
    workingPlace: sharedState.user.profile.workingPlace || "",
    strNumber: sharedState.user.profile.strNumber || "",
    avatar: sharedState.user.profile.avatar,
    fileLocation: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleChangeAvatar = (e) => {
    try {
      const uploadedFile = e.target.files[0];
      if (uploadedFile === undefined) return;
      const fileType = uploadedFile.type.split("/")[0];
      if (uploadedFile.size > IMAGE.SIZE_LIMIT)
        throw new Error("Ukuran gambar melebihi batas limit");
      if (fileType !== "image") throw new Error("Tipe file tidak mendukung");

      setState((prevState) => ({
        ...prevState,
        fileLocation: URL.createObjectURL(uploadedFile),
        avatar: uploadedFile,
      }));
    } catch (error) {
      dispatch("alert", {
        show: true,
        type: "warning",
        message: error.message,
      });
    }
  };

  const handleClose = () => {
    setState({
      name: sharedState.user.name,
      description: sharedState.user.profile.description || "",
      workingPlace: sharedState.user.profile.workingPlace || "",
      strNumber: sharedState.user.profile.strNumber || "",
      avatar: sharedState.user.profile.avatar,
      fileLocation: "",
    });
    if (props.handleClose) props.handleClose();
  };

  const handleSubmit = async () => {
    try {
      const { error } = await updateUserProfileValidator({
        name: state.name,
        workingPlace: state.workingPlace,
        strNumber: state.strNumber,
        description: state.description,
      });
      if (error) throw new Error(error.details[0].message);

      let body = { ...state, _id: sharedState.user._id };
      if (body.fileLocation === "") delete body.avatar;
      delete body.fileLocation;

      dispatch("isLoading", true);
      const { result } = await patchUserProfile(body);
      dispatch("user", result);
      dispatch("isLoading", false);
      if (props.handleClose) props.handleClose();
    } catch (error) {
      dispatch("alert", {
        type: "warning",
        message: error.message,
        show: true,
      });
      dispatch("isLoading", false);
    }
  };

  const imgSrc = state.fileLocation ? state.fileLocation : state.avatar;

  return (
    <Modal
      show={props.show}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
    >
      <div>
        <div className="w-28 mx-auto">
          <div
            style={{ backgroundImage: `url("${imgSrc}")` }}
            className="w-28 h-28 rounded-full bg-center bg-cover mx-auto relative"
          >
            <div className="w-full absolute text-gray-800 text-opacity-30 hover:text-opacity-80 bottom-0 ">
              <div className="relative">
                <div className="w-full text-sm text-center absolute top-1">
                  upload
                </div>
                <input
                  type="file"
                  className="w-full opacity-0"
                  accept="image/jpeg, image/png"
                  name="avatar"
                  onChange={handleChangeAvatar}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Email</div>
          <div
            className={
              "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-40 focus:bg-opacity-30 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg focus:outline-none"
            }
          >
            {sharedState.user.email}
          </div>
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Nama</div>
          <InputText
            type="text"
            className="col-span-12 sm:col-span-9"
            name="name"
            value={state.name}
            onChange={handleChange}
          />
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Tempat Praktek</div>
          <InputText
            type="text"
            className="col-span-12 sm:col-span-9"
            name="workingPlace"
            value={state.workingPlace}
            onChange={handleChange}
          />
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Nomor STR</div>
          <InputText
            type="text"
            className="col-span-12 sm:col-span-9"
            name="strNumber"
            value={state.strNumber}
            onChange={handleChange}
          />
        </div>

        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Description</div>
          <textarea
            className={
              "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-20 focus:bg-opacity-30 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg focus:outline-none "
            }
            rows="3"
            name="description"
            value={state.description}
            onChange={handleChange}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalUserProfile;
